module.exports = __webpack_public_path__ + "media/images/icons/check-white-50f9825a58a59248b6e806eecb734872.svg";